import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Card, Box, Typography, Tooltip, CircularProgress, Grid, Snackbar, Alert, Divider } from '@mui/material';
import { useEffect, useState } from 'react';
import { getScreeningOrderDetails, selectApplicationsState } from '../../../resui/applications/sagas/pm/applicationsSlice';
import { useHistory, useLocation, useParams } from 'react-router';
import ExternalRefResidentIcon from '../../../icons/ExternalRefResidentIcon.svg';
import ExternalRefPropertyIcon from '../../../icons/ExternalRefPropertyIcon.svg';
import MaintenanceBackIcon from '../../../icons/MaintenanceBackIcon.svg';
import ExportIcon from '../../../icons/ExportIcon.svg';

const useStyles = makeStyles({
  gridContainer: {
    background: '#FFFFFF',
    borderRadius: '24px',
  },
});

export default function ScreeningViewer() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const { screeningId: screeningOrderUuidRouteParam, applicationId: applicationUuidRouteParam } = useParams<{ screeningId: string; applicationId: string }>();
  const { state: screeningDashboardState } = useLocation<{ returnQueryString: string; returnPage: string }>();
  const { getScreeningOrderDetailsResponse, getScreeningOrderDetailsError, isGettingScreeningOrderDetailsFailed, isGettingScreeningOrderDetailsSuccess } = useSelector(selectApplicationsState);
  const [isIframeLoading, setIsIframeLoading] = useState(true);
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [globalError, setGlobalError] = useState('');

  const handleAlertClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackBarOpen(false);
  };
  useEffect(() => {
    setIsIframeLoading(true);
    dispatch({ type: getScreeningOrderDetails.type, payload: { screeningOrderUuid: screeningOrderUuidRouteParam } });
  }, [dispatch, screeningOrderUuidRouteParam]);

  useEffect(() => {
    if (isGettingScreeningOrderDetailsSuccess) {
      setGlobalError('');
      setSnackBarOpen(false);
    } else if (isGettingScreeningOrderDetailsFailed) {
      setSnackBarOpen(true);
      setGlobalError(getScreeningOrderDetailsError.message);
    }
  }, [isGettingScreeningOrderDetailsFailed, getScreeningOrderDetailsError, isGettingScreeningOrderDetailsSuccess]);

  return (
    <Box>
      <Snackbar anchorOrigin={{ horizontal: 'center', vertical: 'top' }} open={snackBarOpen} autoHideDuration={4000} onClose={handleAlertClose}>
        <Alert onClose={handleAlertClose} severity="error">
          {globalError}
        </Alert>
      </Snackbar>
      <Card
        sx={{
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          height: 'calc( 100vh - 144px )',
          pb: '64px',
          mt: 3.5,
        }}
        className={classes.gridContainer}
        style={{ position: 'relative' }}
      >
        <>
          <Box sx={{ display: 'flex', p: 1, pb: 2, justifyContent: 'space-between', '& .MuiTextField-root': { m: 1, width: '25ch' } }}>
            <Box display="flex">
              <img
                src={MaintenanceBackIcon}
                style={{ height: '20px', width: '20px', marginRight: '30px', cursor: 'pointer' }}
                alt="back"
                onClick={() => {
                  if (screeningDashboardState?.returnPage === 'Applications') {
                    history.push(`/pmui/applications`, { returnQueryString: screeningDashboardState.returnQueryString });
                  } else history.push(`/pmui/applications/${applicationUuidRouteParam}/summary`, { returnQueryString: screeningDashboardState.returnQueryString });
                }}
              />
              <Typography id="subTitle" ml={2} mr={2}>
                Screeing Report:{' '}
              </Typography>
              <img src={ExternalRefResidentIcon} style={{ height: '20px', width: '20px' }} alt="ExternalRefResidentIcon" />
              <Typography id="subTitle" ml={2} mr={2}>{`${getScreeningOrderDetailsResponse.FirstName || ''} ${getScreeningOrderDetailsResponse.MiddleName || ''} ${
                getScreeningOrderDetailsResponse.LastName || ''
              }`}</Typography>

              <img src={ExternalRefPropertyIcon} style={{ height: '20px', width: '20px' }} alt="ExternalRefPropertyIcon" />
              <Typography id="subTitle" ml={2}>{`${getScreeningOrderDetailsResponse.PropertyName || ''}`}</Typography>
            </Box>
            <Tooltip title="Download Screening as PDF">
              <img
                src={ExportIcon}
                style={{ height: '20px', width: '20px', marginLeft: '20px', cursor: 'pointer' }}
                alt="ExportMaintenanceIcon"
                onClick={() => window.open(getScreeningOrderDetailsResponse.PdfUrl)}
              />
            </Tooltip>
          </Box>
          <Divider />
          <Box height="100%">
            {isIframeLoading ? (
              <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }} mt={2} height={'100%'}>
                <CircularProgress size={40} />
              </Grid>
            ) : null}
            <iframe
              key={getScreeningOrderDetailsResponse.ScreeningOrderUuid}
              sandbox="allow-scripts"
              title="screeningViewer"
              src={getScreeningOrderDetailsResponse.HtmlUrl}
              onError={() => {}}
              onLoad={() => {
                setIsIframeLoading(false);
              }}
              style={{ border: 'none' }}
              width={'100%'}
              height="100%"
            ></iframe>
          </Box>
        </>
      </Card>
    </Box>
  );
}
